import Home from "../components/Home.vue";
import Privacidad from "../components/pages/Privacidad.vue";
import Gestion from "../components/admin/gestion.vue";
import Dashboard from "../components/Dashboard.vue";
import SignIn from "../components/login.vue";
// import Perfil from '../components/admin/profile.vue';
import Registro from "../components/pages/Registro.vue";
import RegisterUser from "../components/pages/RegisterUser.vue";
import RegistroVerify from "../components/pages/Registro-verify.vue";

import Expedientes from "../components/admin/expedientes.vue";
import ExpedientesEdit from "../components/admin/expedientes-edit.vue";
// import Usuarios from '../components/admin/usuariosList.vue';

import Error404 from "../components/error404.vue";

import AdminDashboard from "../components/Admin-Dashboard.vue";
import ListaExpedientes from "../components/admin-pages/lista-expedientes.vue";
import AdminExpedientesEdit from "../components/admin-pages/admin-expedientesEdit.vue";
import AdminInmuebles from "../components/admin-pages/admin-inmuebles.vue";
import AdminInmueblesDetalles from "../components/admin-pages/admin-inmuebles-detalle.vue";

import ListaUsuarios from "../components/admin-pages/lista-usuarios.vue";
import ListaPopietarios from "../components/admin-pages/lista-propietarios.vue";
import AdminPopietarios from "../components/propietarios/Admin-propietarios.vue";
import Perfil from "../components/pages/Profile.vue";

import DashboardPropietario from "../components/propietarios/Dashboard-Propietario.vue";
import UsuarioHome from "../components/propietarios/Home-Propietario.vue";
import Firma from "../components/propietarios/Firma.vue";
import Ayuda from "../components/propietarios/Ayuda.vue";

import ConfigSms from "../components/config-app/config-sms.vue"

// This is where you add all your site routes
// Each route is set as an obect in the array
// For a the most basic route just set
// the path & component to load

export const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/firma",
    name: "firma",
    component: Firma
  },
  {
    path: "/firma/:id",
    component: Firma
  },
  {
    path: "/privacidad",
    name: "privacidad",
    component: Privacidad
  },
  {
    path: "/ayuda",
    name: "ayuda",
    component: Ayuda
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: AdminDashboard,
    meta: {
      ruta: "Dashboard",
      requiresAuth: true,
      requiredLevel: 7,
      breadcrumbs: [
        {
          name: "Dashboard"
        }
      ]
    },
    children: [
      {
        path: "expedientes",
        name: "expedientes-list",
        component: ListaExpedientes,
        meta: {
          ruta: "Expedientes",
          navControl: "expedientesList",
          requiredLevel: 7,
          breadcrumbs: [
            {
              name: "Dashboard",
              link: "dashboard"
            },
            {
              name: "Expedientes"
            }
          ]
        }
      },
      {
        path: "expedientes-edit",
        name: "admin-expedientes",
        component: AdminExpedientesEdit,
        meta: {
          ruta: "Edición Expediente",
          requiredLevel: 7
        }
      },
      {
        path: "expedientes-edit/:id",
        component: AdminExpedientesEdit,
        meta: {
          volver: true,
          ruta: "Edición Expediente | id",
          navControl: "expedienteEdit",
          requiredLevel: 7
        }
      },
      {
        path: "inmuebles",
        name: "admin-inmuebles",
        component: AdminInmuebles,
        meta: {
          ruta: "Inmuebles",
          requiredLevel: 7
        }
      },
      {
        path: "inmuebles/:id",
        component: AdminInmuebles,
        meta: {
          volver: true,
          ruta: "Catastro | Inmuebles",
          navControl: "inmueblesList",
          requiredLevel: 7
        }
      },
      {
        path: "inmuebles-detalle/:ref/:id",
        component: AdminInmueblesDetalles,
        meta: {
          volver: true,
          ruta: "Catastro | Inmuebles | Detalle",
          navControl: "inmuebleEdit",
          requiredLevel: 7
        }
      },
      {
        path: "perfil",
        component: Perfil,
        meta: {
          ruta: "Perfil Usuario",
          requiredLevel: 1
        }
      },
      {
        path: "perfil/:id",
        component: Perfil,
        meta: {
          volver: true,
          ruta: "Perfil Usuario | id",
          navControl: "usuarioEdit",
          requiredLevel: 7
        }
      },
      {
        path: "usuarios",
        component: ListaUsuarios,
        meta: {
          ruta: "Listado Usuarios",
          navControl: "usuariosList",
          requiredLevel: 7
        }
      },
      {
        path: "usuarios/:tipo",
        component: ListaUsuarios,
        meta: {
          volver: true,
          ruta: "Listado Usuarios",
          navControl: "usuariosList",
          requiredLevel: 7
        }
      },
      {
        path: "propietarios",
        name: "lista-propietarios",
        component: ListaPopietarios,
        meta: {
          ruta: "Lista Propietarios",
          requiredLevel: 7
        }
      },
      {
        path: "propietarios/:id",
        component: ListaPopietarios,
        meta: {
          volver: true,
          ruta: "Lista Propietarios | id",
          requiredLevel: 7
        }
      },
      {
        path: "adminpropietarios",
        name: "admin-propietarios",
        component: AdminPopietarios,
        meta: {
          ruta: "Admin Propietarios",
          requiredLevel: 7
        }
      },
      {
        path: "adminpropietarios/:id",
        component: AdminPopietarios,
        meta: {
          volver: true,
          ruta: "Admin Propietarios | id",
          requiredLevel: 7
        }
      },
      {
        path: "configsms",
        name: "config-sms",
        component: ConfigSms,
        meta: {
          ruta: "Configuración SMS",
          requiredLevel: 7
        }
      },
    ]
  },
  {
    path: "/register",
    name: "Registro",
    component: Registro,
    children: [
      {
        path: "phone/:token",
        name: "Registro-Phone",
        component: Registro
      }
    ]
  },
  {
    path: "/register-user",
    name: "RegisterUser",
    component: RegisterUser
  },
  {
    path: "/register-user/:token",
    component: RegisterUser
  },
  {
    path: "/verify-user",
    name: "RegistroVerify",
    component: RegistroVerify
  },
  {
    path: "/verify-user/:token",
    component: RegistroVerify
  },
  /* {
    path: "/reg-verify",
    name: "RegistroVerify",
    component: RegistroVerify
  },
  {
    path: "/reg-verify/:token",
    name: "RegistroVerify-token",
    component: RegistroVerify
  }, */
  {
    path: "/user",
    name: "user",
    component: Dashboard,
    meta: {
      requiresAuth: true,
      requiredLevel: 1
    },
    children: [
      {
        path: "gestion",
        name: "gestion",
        component: Gestion,
        children: [
          {
            path: "perfil",
            name: "perfil",
            component: Perfil,
            meta: {
              requiredLevel: 0
            }
          },
          {
            path: "perfil/:id",
            component: Perfil,
            meta: {
              requiredLevel: 7
            }
          },
          {
            path: "expedientes",
            name: "expedientes",
            component: Expedientes,
            meta: {
              requiredLevel: 7
            }
          },
          {
            path: "expedientes/edit/:id",
            name: "expedientesEdit",
            component: ExpedientesEdit,
            meta: {
              requiredLevel: 7
            }
          } /* ,
                    {
                        path: 'usuarios',
                        name: 'usuarios',
                        component: Usuarios,
                        meta: {
                            requiredLevel: 7
                        }
                    } */
        ]
      }
    ]
  },
  {
    path: "/usuario",
    name: "usuario",
    component: DashboardPropietario,
    meta: {
      requiresAuth: true,
      requiredLevel: 1
    },
    children: [
      {
        path: "home",
        name: "usuario-home",
        component: UsuarioHome
      }
    ]
  },
  {
    path: "/sign-in",
    name: "signIn",
    component: SignIn /* ,
        beforeEnter: (to, from, next) => {
            delete localStorage.token;
            next();
        } */
  },
  {
    path: "/perfil",
    name: "Perfil",
    component: Perfil,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/expedientes",
    name: "expedientes2",
    component: Expedientes,
    meta: {
      requiresAuth: true,
      requiredLevel: 5
    }
  },
  {
    path: "/404",
    name: "404",
    component: Error404
  },
  {
    path: "*",
    redirect: "/404"
  }
];
